const PREFIX = 'qnaread.notify.';

export function getNotificationPrefs() {
  return {
    revisionReminders: localStorage.getItem(`${PREFIX}revision`) !== '0',
    weeklySummary: localStorage.getItem(`${PREFIX}weekly`) !== '0',
    productUpdates: localStorage.getItem(`${PREFIX}product`) !== '0',
  };
}

export function setNotificationPrefs(prefs) {
  localStorage.setItem(`${PREFIX}revision`, prefs.revisionReminders ? '1' : '0');
  localStorage.setItem(`${PREFIX}weekly`, prefs.weeklySummary ? '1' : '0');
  localStorage.setItem(`${PREFIX}product`, prefs.productUpdates ? '1' : '0');
}
